import { SkinTone } from '@seddi/ui-babylon-fitroom';
import React, { FC, useCallback, useState } from 'react';
import { useSelector, useStore } from 'react-redux';
import { SkinButton, SkinPopup } from 'ui';
import { updateAvatarDisplay } from '../actions/homeAvatarDisplay';
import { HomeState } from '../store/homeState';
import * as S from './homeSkin.styles';

const useSkin = () => {
  const { dispatch } = useStore<HomeState>();

  // Skin state from store
  const skin = useSelector((state: HomeState) => state.avatarDisplaySkin);

  const [isSelected, setSelected] = useState<boolean>(false);

  return { dispatch, isSelected, setSelected, skin };
};

export const HomeSkin: FC = () => {
  const { dispatch, isSelected, setSelected, skin } = useSkin();

  const onChange = useCallback(
    (skin: SkinTone) => {
      updateAvatarDisplay(dispatch, { skin });
    },
    [dispatch],
  );

  const onClick = useCallback(() => {
    setSelected(!isSelected);
  }, [isSelected, setSelected]);

  return (
    <S.Layout>
      {isSelected && <SkinPopup selection={skin} onChange={onChange} />}
      <SkinButton isSelected={isSelected} skin={skin} onClick={onClick} />
    </S.Layout>
  );
};
